import { styled } from '@mui/material'
import { ColumnFlexContainer } from '@collaborate-health/uikit'

export const Container = styled(ColumnFlexContainer)(({ theme }) => ({
  width: '100%',
  height: '100%',
  padding: `0 ${theme.spacing()} ${theme.spacing()}`,
}))
